import React, { memo } from 'react'
import { CombinedPIICollectionForm } from './CombinedPIICollectionForm'

const PIICollectionComponent = () => {
  return <CombinedPIICollectionForm />
}

export const PIICollection = memo(PIICollectionComponent)
